import './bootstrap'
import 'babel-polyfill'

import Vue from 'vue'
import Axios from 'axios'
import Lodash from 'lodash'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import VueLodash from 'vue-lodash'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import VueUUID from "vue-uuid";
// import BootstrapVueTreeview from 'bootstrap-vue-treeview'
// import VTreeview from "v-treeview"

const VuetifyProps = {}
if(window.esApp.Theme.primary.length > 0){
    VuetifyProps.theme = {
        primary: window.esApp.Theme.primary,
        secondary: window.esApp.Theme.secondary,
        accent: window.esApp.Theme.accent,
        error: window.esApp.Theme.error,
        warning: window.esApp.Theme.warning,
        info: window.esApp.Theme.info,
        success: window.esApp.Theme.success
    }
}

Vue.use(VueLodash, {lodash: Lodash})
Vue.use(Vuetify, VuetifyProps)
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VeeValidate)
Vue.use(VueUUID)

import store from './store'
import router from './router'
import './components'
import './views'

const messages = {}

const i18n = new VueI18n({
    locale: 'pt',
    messages
})

Axios.get('/locale/pt.json').then(response => {
    messages.pt = response.data
    store.state.language = 'pt'
    const app = new Vue({
        el: '#app',
        router,
        i18n,
        store,
        computed: {
            company: {
                get: () => {
                    return store.getters.company
                },
                set: (value) => {
                    store.commit('company', value)
                }
            }
        }
    })
})
Axios.get('/locale/en.json').then(response => {
    messages.en = response.data
})
Axios.get('/locale/es.json').then(response => {
    messages.es = response.data
})
Axios.get('/locale/fr.json').then(response => {
    messages.fr = response.data
})



// WEBPACK FOOTER //
// ./resources/js/app.js